import { Icon } from '../icons/Icon.jsx';

/* 모달 다이얼로그. veil 클릭 시 닫힘, 내부 클릭은 전파 차단. */
export function Modal({ title, sub, wide, onClose, children, foot }) {
  return (
    <div className="veil" onMouseDown={onClose}>
      <div className={"modal" + (wide ? " modal--wide" : "")} onMouseDown={e => e.stopPropagation()}>
        <div className="modal__head">
          <div>
            <div className="modal__title">{title}</div>
            {sub && <div className="modal__sub">{sub}</div>}
          </div>
          <button className="icon-btn icon-btn--ghost modal__close" onClick={onClose}><Icon name="close" size={20} /></button>
        </div>
        <div className="modal__body">{children}</div>
        {foot && <div className="modal__foot">{foot}</div>}
      </div>
    </div>
  );
}

export default Modal;
